import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";
import { api, errMsg, fmtDate } from "../lib/api";

export const MyPasswordRequestBanner = () => {
  const [req, setReq] = useState(null);
  useEffect(() => { api.get("/auth/my-password-request").then((r) => setReq(r.data)).catch(() => {}); }, []);
  if (!req) return null;
  const cancel = async () => {
    try {
      await api.delete("/auth/my-password-request");
      toast.success("Password change request cancelled");
      setReq(null);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div data-testid="my-password-request-banner" className="mb-6 flex flex-col gap-3 rounded-xl border border-amber-500/30 bg-amber-500/10 px-5 py-4 text-sm text-amber-200 sm:flex-row sm:items-center">
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span className="flex-1">A password change for your account was requested on {fmtDate(req.created_at)} and is waiting for approval. If this wasn't you, cancel it.</span>
      <button data-testid="cancel-my-password-request-button" onClick={cancel} className="shrink-0 rounded-lg border border-amber-500/40 px-3 py-1.5 text-xs font-semibold hover:bg-amber-500/20">Cancel request</button>
    </div>
  );
};
